// Shared by every trigger type; `AlertAggregationType` adds the alert-only ones.
export var TriggerAggregationType;
(function (TriggerAggregationType) {
    TriggerAggregationType["Count"] = "COUNT";
    TriggerAggregationType["Min"] = "MIN";
    TriggerAggregationType["Max"] = "MAX";
    TriggerAggregationType["Avg"] = "AVG";
    TriggerAggregationType["Sum"] = "SUM";
    TriggerAggregationType["UniqueCount"] = "UNIQUE_COUNT";
})(TriggerAggregationType || (TriggerAggregationType = {}));
//# sourceMappingURL=triggers.enum.js.map